<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" width="600px">
            <template v-slot:activator="{ on }">
                <v-btn block color="primary" text dark v-on="on">Создать группу</v-btn>
            </template>
            <v-card>
                <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Группа клиентов</v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn class="error--text" dark text @click="removeGroup(index)"
                               v-if="mailingGroupModel.id !== null"
                        >Удалить</v-btn>
                        <v-btn dark text @click="saveValue" :disabled="!valid">
                            <v-icon>save</v-icon>
                            {{mailingGroupModel.id === null ? 'Создать' : 'Сохранить'}}
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list three-line subheader class="content">
                    <v-container>
                        <v-form
                                ref="form"
                                v-model="valid"
                        >
                            <v-row class="d-flex">
                                <v-col cols="12" md12 class="py-0">
                                    <v-text-field
                                            v-model="mailingGroupModel.title"
                                            :counter="40"
                                            label="Название группы"
                                            required
                                            class="ma-2 pa-2"
                                            :rules="[rules.required, rules.maxLengthTitle]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-textarea
                                            rows="5"
                                            name="input-7-1"
                                            :counter="500"
                                            v-model="mailingGroupModel.description"
                                            label="Описание группы"
                                            class="ma-2 pa-2 my-0 py-0"
                                            :rules="[rules.maxLengthDescription]"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="10" md10 class="py-0">
                                    <v-text-field
                                            v-model="url"
                                            label="Ссылка на эту группу"
                                            required
                                            :readonly="true"
                                            hide-details
                                            ref="urlText"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2" md2 class="mb-auto" v-if="mailingGroupModel.id !== null">
                                    <v-tooltip left bottom >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                    depressed
                                                    fab
                                                    small
                                                    text
                                                    v-on="on"
                                                    v-clipboard:copy="url"
                                                    v-clipboard:success="onCopy"
                                                    v-clipboard:error="onError"
                                            >
                                                <v-icon small color="blue lighten-2">file_copy</v-icon>
                                            </v-btn>
                                        </template>
                                        <span >Скопировать ссылку в буфер обмена</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="6" md12 class="py-0">
                                    <v-text-field
                                            v-model="mailingGroupModel.button_subscribe"
                                            :counter="20"
                                            label="Подпись кнопки подписаться"
                                            class="ma-2 pa-2"
                                            :rules="[rules.maxLengthButton]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" md12 class="py-0">
                                    <v-select
                                            :items="messagesInModel"
                                            v-model="mailingGroupModel.message_subscribe"
                                            label="Сообщение при подписке"
                                            class="ma-2 pa-2"
                                            item-text="title"
                                            item-value="id"
                                    ></v-select>
                                </v-col>
                                <v-col cols="6" md12 class="py-0">
                                    <v-text-field
                                            v-model="mailingGroupModel.button_unsubscribe"
                                            :counter="20"
                                            label="Подпись кнопки отписаться"
                                            class="ma-2 pa-2"
                                            :rules="[rules.maxLengthButton]"

                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" md12 class="py-0">
                                    <v-select
                                            :items="messagesInModel"
                                            v-model="mailingGroupModel.message_unsubscribe"
                                            label="Сообщение при отписке"
                                            class="ma-2 pa-2"
                                            item-text="title"
                                            item-value="id"
                                    ></v-select>
                                </v-col>
                                <v-col cols="6" md12 class="py-0">
                                    <v-switch v-model="mailingGroupModel.visible_group"
                                              class="ma-2 pa-2 my-0 py-1"
                                              inset
                                              label="Видимость на главной странице" color="primary"
                                              :false-value="0"
                                              :true-value="1"
                                              hide-details
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-switch v-model="mailingGroupModel.visible_count_subscribe"
                                              class="ma-2 pa-2 my-0 py-1"
                                              inset
                                              label="Количество подписчиков" color="primary"
                                              :false-value="0"
                                              :true-value="1"
                                              hide-details
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-switch v-model="mailingGroupModel.main"
                                              class="ma-2 pa-2 my-0 py-1"
                                              inset
                                              label="Главная группа" color="primary"
                                              :false-value="0"
                                              :true-value="1"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-select v-model="mailingGroupModel.type"
                                              class="ma-2 pa-2 my-0 py-1"
                                              :items="[{ value: 1, text: 'Обычный'}, { value: 2, text: 'Менеджеры'}]"
                                              inset
                                              label="Тип группы" color="primary"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-6">
                                    <v-btn @click="visible = true">Выбрать изображение</v-btn>
                                </v-col>
                                <v-col v-if="mailingGroupModel.image !== null" cols="12" md12 class="py-0">
                                        <v-img
                                                :src="mailingGroupModel.image"
                                                class="text-right ma-2 pa-2"
                                        >
                                        </v-img>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
        <dialog-confirmation
                ref="confirm"
                :dialogParams="dialogParams">
        </dialog-confirmation>
        <client-mailing-group-select-image
                v-if="renderAttachmentBlock"
                :model="mailingGroupModel"
                :visible="visible"
                @selectImage="selectImage"
                @close="visible = false"
        >
        </client-mailing-group-select-image>

    </v-layout>
</template>

<script>

import { mapGetters } from 'vuex'
import DialogConfirmation from '../../dialogs/DialogConfirmation'
import ClientMailingGroupSelectImage from './ClientMailingGroupSelectImage'
import constConf from '../../../constconf'
export default {
    name: 'ClientMailingGroupForm',
    props: ['index', 'dialog'],
    components: {
        DialogConfirmation,
        ClientMailingGroupSelectImage
    },
    data() {
        return {
            show: false,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            mailingGroupModel: { id: null, main: 0 },
            dialogParams: {},
            visible: false,
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length <= 40) || 'Максимальная длина названия 28 символов.',
                maxLengthDescription: value => (value === null || value.length <= 500) || 'Максимальная длина описания 295 символов.',
                maxLengthButton: value => (value === null || value.length <= 20) || 'Максимальная длина названия 20 символов.',
                urlValid: value => (value !== null ? !!value.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9А-яЁё]+([\-\.]{1}[a-z0-9А-яЁё]+)*\.[a-zА-яЁё]{2,10}(:[0-9]{1,5})?(\/.*)?$/g) : false) || 'Ссылка имеет неверный формат. Пример верного формата https://app.chatway.ru/'
            },
            valid: false,
            renderAttachmentBlock: false
        }
    },
    computed: {
        ...mapGetters({
            messages: 'messages/messages',
            mailingGroups: 'clients/allMailingGroups',
            mailingGroupModelDef: 'clients/mailingGroupModelDef',
            botId: 'appVk/botId',
            allowMessagesGroupList: 'appVk/allowMessagesGroupList'
        }),
        messagesInModel () {
            return [{ id: 0, title: 'Без сообщения' }].concat(this.messages)
        },
        url() {
            return this.mailingGroupModel.id == null ? '' : 'https://vk.com/app' + constConf.appVkId + '_-' + this.$route.query.vk_group_id + '#m=' + this.mailingGroupModel.id
        }
    },
    methods: {
        saveValue () {
            this.$store.dispatch('clients/saveMailingGroup', this.mailingGroupModel).then(response => {
                this.snackbar = true
                this.mailingGroupModel.id = response.id
            }, error => {
                console.log(error)
            })
        },
        loadModel(index = null) {
            if (index === null) {
                this.mailingGroupModel = Object.assign({}, this.mailingGroupModelDef)
            } else {
                this.mailingGroupModel = Object.assign({}, this.mailingGroups[index])
            }
        },
        async removeGroup (index) {
            this.$refs.confirm.open('Удаление группы', 'Вы действительно хотите удалить?',
                { color: 'red', agree: 'Подтверждаю', cancel: 'Отмена' })
                .then((confirm) => {
                    if (confirm === true) {
                        this.$store.dispatch('clients/removeMailingGroup', index).then(response => {
                            if (response !== undefined && response.data.hasOwnProperty('success')) {
                                this.paramsSnackbar.color = 'success'
                                this.paramsSnackbar.text = response.data.success.text
                            } else {
                                this.paramsSnackbar.color = 'error'
                                this.paramsSnackbar.text = 'Ошибка удаления группы!'
                            }
                            this.snackbar = true
                            this.show = false
                        }, error => {
                            console.error('Ошибка удаления группы, попробуйте еще раз')
                        })
                    }
                })
        },
        selectImage (link) {
            this.mailingGroupModel.image = link
        },
        onCopy() {
            this.paramsSnackbar.color = 'success'
            this.paramsSnackbar.text = 'Ссылка успешно скопирована!'
            this.snackbar = true
        },
        onError() {
            this.paramsSnackbar.color = 'error'
            this.paramsSnackbar.text = 'Ошибка при копировании'
            this.snackbar = true
        }
    },
    watch: {
        dialog() {
            if (this.dialog === true) {
                this.loadModel(this.index)
                this.show = true
                this.renderAttachmentBlock = true
            } else {
                this.show = false
            }
        },
        show() {
            if (this.show === false) {
                this.mailingGroupModel = Object.assign({}, this.mailingGroupModelDef)
                this.$refs.form.resetValidation()
                this.$emit('close')
            } else {
                if (this.botId != null) {
                    this.$store.dispatch('clients/changeBotIdModelDefault', this.botId)
                    this.mailingGroupModel.bot_id = this.botId
                }
            }
        }
    },
    created() {
        if (this.$route.matched.length > 0 && this.$route.matched[0].path !== '/appvk') {
            this.$store.dispatch('clients/changeBotIdModelDefault', this.$route.params['pathMatch'])
            this.$store.dispatch('messages/messageAll', this.$route.params['pathMatch'])
        }
        this.mailingGroupModel = Object.assign({}, this.mailingGroupModelDef)
        this.mailingGroupModel.bot_id = this.$route.params['pathMatch']
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
    .container {
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
    .v-text-field {
        font-size: 0.9em;
    }
</style>
